// load templates
require('./sidebar-template.html');

// create ngModule
angular.module('bbl.layout.sidebar', [])
  .controller('SidebarController', ['$scope', '$rootScope', '$timeout', 'Api', '$location', 'Auth', 'Toast', 'modals', Controller]);

var isVisible = false;
function Controller($scope, $rootScope, $timeout, Api, $location, Auth, Toast, modals) {
  $scope.visible = isVisible;
  $scope.firstBridge = null;

  Api.bridges.sub(function(bridges) {
    $scope.bridges = bridges;
  });

  Auth.getPermission().then(function(response) {
    $scope.permission_level = response.data.permission_level;
  }).catch(angular.noop);

  $scope.isActive = function (viewLocation) {
    // return viewLocation === $location.path();
    return $location.path().indexOf(viewLocation) != -1;
  };

  $scope.togglePanel = function($event, panelId) {
    var panel = $('#'+panelId);
    if(panel.length === 0) {
      return false;
    }
    // $event.preventDefault();
    panel.slideToggle(400);
  };

   $scope.openPanel = function($event, panelId) {
    var panel = $('#'+panelId);
    if(panel.length === 0) {
      return false;
    }
    // $event.preventDefault();
    panel.slideDown(400);
  };

  $scope.snoozed = Toast.muted.bind(Toast);
  $scope.notifSettings = function() {
    $.fn.modal.call(modals.snoozeNotifications($scope));
  };

  $scope.user = Auth.userInfo;

  $scope.hide = function() {
    $timeout(function() {
      $scope.visible = toggle(false);
    });
  };

  var handleHideClick = function(ev) {
    if (ev && (!document.contains(ev.target) || $(ev.target).parents('.sidebar-section > .row').length)) {
      return;
    }

    $scope.hide();
    document.removeEventListener('click', handleHideClick);
  };

  $scope.show = function() {
    $scope.visible = toggle(true);
    setTimeout(function() {
      document.addEventListener('click', handleHideClick);
    });
  };

  var toggle = function(toggl) {
    return (isVisible = typeof toggl === 'boolean' ? toggl : !isVisible);
  };

  $scope.$on('show:sidebar', $scope.show);

  $scope.$on('$routeChangeStart', handleHideClick.bind(0, null));
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/sidebar-controller.js
 ** module id = 86
 ** module chunks = 0
 **/